
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css'
import DashboardTabs from './components/DashboardTabs';
import LeadTabs from './components/LeadTabs';
import IssuesTable from './components/IssuesTable';
const App = () => {
  const location = useLocation();
  const isLoginRoute = location.pathname === "/login";

  return (
    <div className={`App ${isLoginRoute ? "login-app" : "workspace-app"}`}>
      <Navbar />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/email-automation" element={<ProtectedRoute><DashboardTabs /></ProtectedRoute>} />
        <Route path="/civinex-leads" element={<ProtectedRoute><LeadTabs /></ProtectedRoute>} />
        <Route path="/civinex-issues" element={<ProtectedRoute><IssuesTable /></ProtectedRoute>} />
        <Route path="/upload" element={<Navigate to="/email-automation" replace />} />
        <Route path="*" element={<Navigate to="/email-automation" />} />
      </Routes>
    </div>
  );
};

export default App;
